import clientAxios from "../config";

/**
 * Envía un mensaje del formulario público de contacto.
 *
 * payload = { name, email, subject, phone?, message }
 *
 * No requiere autenticación — el endpoint del back es público con
 * throttle estricto (5 envíos por minuto por IP).
 */
const sendContactMessage = (payload) =>
    clientAxios.post(`/api/contact`, payload);

export { sendContactMessage };
